"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mfl = void 0;
var MflParser_1 = require("./lang/MflParser");
var execNode_1 = require("./lang/execNode");
exports.Mfl = Object.freeze({
    tokens: {
        operators: ['+', '-', '*', '/'],
    },
    compile: function (formula) {
        var ast = MflParser_1.MflParser.parse(formula);
        var exec = function (scope) { return (0, execNode_1.execNode)(ast, scope); };
        return Object.freeze({ exec: exec, source: formula });
    },
    exec: function (formula, scope) {
        var ast = MflParser_1.MflParser.parse(formula);
        return (0, execNode_1.execNode)(ast, scope);
    }
});
